import React from "react"
import styled from "styled-components"
import { Headline, StyledGradientTitle } from "../../../utils"
import { Hexagon } from "../../atoms/Hexagon"

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background: ${(props) => props.theme.bgRadialDeepBlue2};
  padding: 80px 20px;
  @media (max-width: 1023px) {
    padding: 60px 50px;
  }
  @media (max-width: 600px) {
    padding: 40px 20px;
  }
  .hexagon-container {
    display: flex;
    align-items: center;
    margin-bottom: 80px;
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
    }
    @media (max-width: 1200px) {
      gap: 12px;
    }
    .first {
      margin-right: -5.75rem;
      @media (max-width: 1200px) {
        margin-right: -3.5rem;
      }
      @media (max-width: 768px) {
        margin: 0;
      }
    }
    .fourth {
      margin-left: -5.75rem;
      @media (max-width: 1200px) {
        margin-left: -3.5rem;
      }
      @media (max-width: 768px) {
        margin: 0;
      }
    }

    .inner-hexagon-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 20px;
      @media (max-width: 1200px) {
        gap: 12px;
      }
    }
  }
`

const ExperienceSection = () => {
  return (
    <Container>
      <Headline>
        {"Experience the "}
        <StyledGradientTitle>{"Perks"}</StyledGradientTitle>
        {" of being valued member of "}
        <StyledGradientTitle>{"RTW"}</StyledGradientTitle>
      </Headline>
      <div className="hexagon-container">
        <Hexagon type="motivation" className={"first"} />
        <div className="inner-hexagon-container">
          <Hexagon type="growth" className="second" />
          <Hexagon type="entertainment" className="third" />
        </div>
        <Hexagon type="workLife" className="fourth" />
      </div>
    </Container>
  )
}

export { ExperienceSection }
